import * as React from 'react';
import { PureIconContainer } from './utils/IconContainer';
var Upvote = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_Upvote_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 6.5c2.034-.148 3.619-2.34 3.676-4.436a.215.215 0 0 1-.001-.048l.001-.042C6.676.884 7.544 0 8.614 0c.92 0 1.688.653 1.887 1.528.109.5.178 1.018.178 1.55a10.8 10.8 0 0 1-.158 1.737 6.695 6.695 0 0 1-.242 1l3.718.004c.034 0 .068.004.1.009a1.969 1.969 0 0 1 1.607.95c.229.375.32.798.29 1.208l-.019.229-1.118 5.555A2.966 2.966 0 0 1 11.987 16l-1.13.001H3v-.001l-2.002-.005a1 1 0 0 1-.998-1V7.5a1 1 0 0 1 1-1h2ZM4 15l7.987-.001a1.966 1.966 0 0 0 1.896-1.455l1.1-5.471.014-.165a1.03 1.03 0 0 0-.147-.61.969.969 0 0 0-.793-.471L14 6.825l-.036-.006-5.086-.005.455-1.324c.205-.599.346-1.662.346-2.411 0-.445-.057-.888-.154-1.333A.945.945 0 0 0 8.615 1c-.502 0-.939.419-.939.974v.041l.002.02-.002.056c-.035 1.277-.53 2.555-1.313 3.543C5.764 6.388 4.957 7.019 4 7.32V15ZM3 7.5v7.499l-2-.005V7.5h2Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_Upvote_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
export default Upvote;